document.addEventListener("DOMContentLoaded", function() {

  let template = document.querySelector(".template-product")
  if(template){

    const intervalId = setInterval(function() {
      const mainImage = document.querySelector(".carousel__slide.product-media-carousel__slide.is-selected") // Busca el elemento por su ID o selector
      const allMainImage =  document.querySelectorAll(".carousel__slide.product-media-carousel__slide")
      const thumbs = document.querySelectorAll(".carousel__slide.product-thumbnail-carousel__thumb")

      if (mainImage) {
        let currImage = mainImage.dataset.variant.toLowerCase()
        thumbs.forEach((item) => {
          if(item.dataset.variant == currImage){
            item.classList.add("show--image")
          }          
        });
        //console.log("Elemento encontrado. Deteniendo el intervalo.");
        clearInterval(intervalId); // Detener el intervalo    
  
      } else {
          console.log("Buscando el elemento...");
      }
    }, 1000); // El intervalo se ejecuta cada 1 segundo (1000 ms)

    const swatch = document.querySelectorAll("color-swatches-picker .color-swatch-select-parent")

    swatch.forEach((item) => {
      item.addEventListener("click", (e) => {
        let currColor = e.target.dataset.color.toLowerCase()
        const thumbs = document.querySelectorAll(".carousel__slide.product-thumbnail-carousel__thumb")
        thumbs.forEach((item) => {
         item.classList.remove("show--image")
          if(item.dataset.variant == currColor){
            item.classList.add("show--image")
          }          
        });
        
      });
    });

  }
});